var _circle, _line, _circle2, _circle3, _line2, _circle4, _path, _line3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIlCollaborate1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 624,
    height: 338,
    viewBox: "0 0 624 338",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 29.5,
    transform: "matrix(-1 0 0 1 444.5 201.5)",
    fill: "#1CF8BD"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 504.5,
    y1: 201.5,
    x2: 716.5,
    y2: 201.5,
    stroke: "#1CF8BD",
    strokeWidth: 19,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 41.5,
    transform: "matrix(-1 0 0 1 177.5 201.5)",
    fill: "#1CF8BD"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 27.5,
    transform: "matrix(-1 0 0 1 531.5 310.5)",
    fill: "#5C1FDE"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 586.5,
    y1: 310.5,
    x2: 798.5,
    y2: 310.5,
    stroke: "#5C1FDE",
    strokeWidth: 19,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 41.5,
    transform: "matrix(-1 0 0 1 41.5 41.5)",
    fill: "#5C1FDE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M475.5 309.5H396.5C342.376 309.5 298.5 265.624 298.5 211.5V139.517C298.5 85.1917 254.309 41.2326 199.984 41.5185L108.5 42",
    stroke: "#5C1FDE",
    strokeWidth: 19,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 246.5,
    y1: 201.5,
    x2: 385.5,
    y2: 201.5,
    stroke: "#1CF8BD",
    strokeWidth: 19,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlCollaborate1);
export default __webpack_public_path__ + "static/media/il_collaborate1.b998b63e7fb1618407adfa8d75a0e690.svg";
export { ForwardRef as ReactComponent };